import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IItemDetailList, IMaterialDetailList, IChargebackList, ItemDetailed, MaterialDetailed, IChargebackSettle, IChargebackField, IChargebackSearch, IChargebackDetail, IChargebackRoSettleAndWhConfirm } from "./chargebackTypes"
class ChargebackService {
    async page(searchVo: IChargebackSearch) {
        const apiUrl = "/repair/return/findPage";
        return await httpRequest.post<IChargebackList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/repair/return/findById/${id}`;
        return await httpRequest.get<IChargebackDetail>(apiUrl);
    }

    async insert(insertVo: IChargebackField) {
        const apiUrl = "/repair/return/insert";
        return await httpRequest.post<IChargebackDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IChargebackField) {
        const apiUrl = "/repair/return/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // 库房确认
    async warehousing(params: IChargebackRoSettleAndWhConfirm) {
        const apiUrl = "/repair/return/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IChargebackSettle) {
        const apiUrl = "/repair/return/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修用料明细删除
    async materialDelete(params: MaterialDetailed) {
        const apiUrl = "/vrm-sa/maintenance/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修项目明细删除
    async itemDelete(params: ItemDetailed) {
        const apiUrl = "/vrm-sa/maintenance/itemDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }

    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/maintenance/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/vrm-sa/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/vrm-sa/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //打印
    async printing(params: object) {
        const apiUrl = "/vrm-sa/maintenance/printing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //工单批量导出
    async export(params: IChargebackSearch) {
        const apiUrl = "/repair/return/export";
        return await httpRequest.postFile(apiUrl, params,{ timeout: 600000 });
    }
    //工单详情导出
    async detailsExport(params: object) {
        const apiUrl = "/repair/return/detailsExport";
        return await httpRequest.postFile(apiUrl, params,{ timeout: 600000 });
    }
}
export const chargebackService = new ChargebackService();
